export const Dictionary = {
    Basic: {
        ShowMore: "zobrazit více",
        MyOrders: "Moje objednávky",
    },
    Default: {
        InsertedToBasket: "Přidáno do košíku",
        BasketUrl: "/nakupni-kosik",
        PleaseInsertPhoneNumber: "Prosím zadejte platné telefonní číslo.",
        PleaseInsertValidEmail: "Prosím, zadejte platný e-mail.",
        PleaseCheckValidZip: "Zkontrolujte prosím zadané PSČ",
        ThisAddressHasBeenAlreadyUsed: "Tato adresa již byla pro registraci použita",
        PleaseInsertValidPhoneNumber: "Prosím zadejte platné telefonní číslo",
        ProblemDuringProductSizeSelection: "Problém při výběru velikosti produktu. Zkuste stránku obnovit a vložit produkt do košíku opakovaně. Pokud by problém přetrvával, obraťte se na nás přes info@odkarla.cz.",
        NeedShippingMethodSelect: "Je třeba vybrat způsob přepravy",
        InvalidShippingPaymentMethodCombination: "Tato kombinace dopravy a platby nelze vybrat. Zvolte prosím jinou kombinaci dopravy a platby.",
        NeedPaymentAgree: "Je třeba souhlasit s podmínkami platby.",
        NoInvoiceAddress: "Není vložená žádná fakturační adresa. Klikněte na tlačítko \"Nová fakturační adresa\" a zadejte prosím Vaši fakturační adresu.",
        NoInvoiceDeliveryAddress: "Není vložená žádná fakturační a dodací adresa. Klikněte na tlačítko \"Nová fakturační adresa\" a \"Nová dodací adresa\" a zadejte prosím Vaši fakturační a dodací adresu.",
        AreYouSureToRemoveAddress: "Opravdu si přejete smazat tuto adresu?",
        PleaseInsertNameSurname: "Zkontrolujte prosím jméno a příjmení",
        PleaseInsertAddress: "Zkontrolujte prosím adresu",
        PleaseInsertIdNo: "Zkontrolujte prosím IČ",
        PleaseInsertVatNo: "Zkontrolujte prosím DIČ",
        InvalidUsernamePassword: "Chybně zadaná kombinace jména a hesla.",
    },
    Validation: {
        ZipRegEx: {
            CZ: /^[1-7]\d{4}$/,
            SK: /^[089]\d{4}$/,
            DE: /^\d{5}$/,
            AT: /^\d{4}$/,
            PL: /^\d{2}-?\d{3}$/,
            FR: /^\d{5}$/,
            IT: /^\d{5}$/,
            NO: /^\d{4}$/,
            NL: /^\d{4}(\s)?[A-z]{2}$/,
            HU: /^\d{4}$/,
            DK: /^\d{4}$/,
            CH: /^\d{4}$/,
        },
        PhoneRegEx: {
            CZ: /^[2-7]\d{8}$/,
            SK: /^0?[29]\d{8}$/,
            DE: /^\d+$/,
            AT: /^\d+$/,
            PL: /^\d+$/,
            FR: /^\d+$/,
        },
        IdNoRegEx: /^\d{8}$/,
        VatNoRegEx: /^\w{2}\d{8,10}$/,
    },
};
